import React from "react";
import Header from "../components/header/Header";
import FloatingButton from "../components/bottomtotop/FloatingButton";
import { TbCloudUp, TbRosetteDiscountCheck } from "react-icons/tb";
import Footer from "../components/footer/Footer";
import features1 from "../../assets/Image/features1.png";
import features2 from "../../assets/Image/features2.png";
import features3 from "../../assets/Image/features3.png";
import features4 from "../../assets/Image/features4.png";
import features5 from "../../assets/Image/features5.png";
import features6 from "../../assets/Image/features6.png";
import features7 from "../../assets/Image/features7.png";
import features8 from "../../assets/Image/features8.png";
import features9 from "../../assets/Image/features9.png";
import features10 from "../../assets/Image/features10.png";
import features11 from "../../assets/Image/features11.png";
import features12 from "../../assets/Image/features12.png";
import features13 from "../../assets/Image/features13.png";
import features14 from "../../assets/Image/features14.png";

const Features = () => {
  const steps = [
    {
      number: "01",
      title:
        "One App for Brands, Sales Reps, Distributors, Wholesalers, Dealers & Retailers",
      description:
        "Selzor is a powerful and adaptable B2B platform tailored for seamless order management — strictly orders, no payment processing. With a single login, you can operate as both a 'Seller' (to receive orders) and a 'Buyer' (to place orders). What's more, Selzor allows you to register as multiple Sellers and Buyers using the same account. Switching between Seller and Buyer modes is effortless and instant.",
      paragraph:
        "This unique flexibility empowers you to simultaneously accept orders from your customers and place new ones with your suppliers — all from within the same app.",
      points: [
        "How to Activate 'Seller' Mode to Receive Orders",
        "How to Activate 'Buyer' Mode to Place Orders",
      ],
      image: features1,
      reverse: false,
    },
    {
      number: "02",
      title: "Advanced Configuration Options",
      description:
        "Selzor offers in-depth customization for nearly every element of your product catalogue. From defining product attributes to choosing how they appear in printed materials, you have total control. Decide which attributes are shown in downloadable PDFs and order summaries. Create your own product tags such as 'Best Seller', 'New Arrival', and more. Configure stock statuses and assign territories easily.",
      points: [
        "General System Settings",
        "Attribute Settings for Products",
        "Import from Excel & Print Format Settings",
        "Import from Excel & Print Format Settings",
        "Custom Badges",
        "Inventory Status",
        "Storage Locations (Warehouses)",
        "Regional Territories",
        "Tailored Order Fields",
      ],
      image: features2,
      reverse: true,
    },
    {
      number: "03",
      title: "Customizable Product Catalogue",
      description:
        "Built to support a wide range of industries, Selzor enables you to design a product catalogue that aligns perfectly with your business model. Simply select the applicable product attributes and build your catalogue as needed.",
      paragraph:
        "Supported fields include: Product Code, Product Name, Category, SKU, Sizes, Order Units, MOQ, Highlights, Packaging Info, HSN Code, Warranty Terms, Stock Locations, Multiple Price Options, Technical Specs, Feature Listings, Links, Photo Gallery, and Inventory Levels.",
      points: ["Setting Up Product Attributes"],
      image: features3,
      reverse: false,
    },
    {
      number: "04",
      title: "Quick Product Setup with Excel Upload",
      description:
        "Avoid manual data entry with Selzor’s Excel Import Wizard. Simply upload your existing price list in Excel format and let Selzor handle the rest. It even reads and creates categories based on the 'Category' column in your file. Any formatting or compatibility issues are flagged in red for easy correction. Once cleaned, your data is uploaded instantly with a single click.",
      points: [
        "Preparing Excel Files for Import",
        "Step-by-Step Excel Upload Guide",
      ],
      image: features4,
      reverse: true,
    },
    {
      number: "05",
      title: "Hierarchical Category Structure",
      description:
        "Selzor allows you to implement a multi-level category system in your product catalog. Each product can be associated with more than one category. These categories can be grouped using nesting, making catalogue navigation easy and logical.",
      paragraph:
        "You can create up to 10 levels of nested categories. These can include both product-linked categories and structural (navigation-only) categories.",
      points: [
        "Using Category Nesting",
        "Arranging Product Order within Categories",
      ],
      image: features5,
      reverse: false,
    },
    {
      number: "06",
      title: "Showcase Multiple Images per Product",
      description:
        "Make your catalogue visually rich by adding multiple images for each product. This feature enhances clarity and helps buyers make better decisions.",
      paragraph: `Format: JPG
                  Max Size: 2 MB per image
                  Aspect Ratio: 1:1
                  Recommended Dimensions: 800 x 800 px
                  Color Profile: RGB
                  Resolution: 72 DPI`,
      points: ["Managing the Photo Gallery"],
      image: features6,
      reverse: true,
    },
    {
      number: "07",
      title: "Rich Product Content & PDF Datasheets",
      description:
        "Selzor enables you to enhance your product listing with informative and detailed content. You can add:",
      paragraph: `Concise Product Descriptions
                  Bullet Points for Product Features
                  Two-column Technical Specification Tables
                  External Website or Brochure Links
                  Generate pixel-perfect product datasheet PDFs instantly. Choose to include either all attributes or only selected public fields. Sections can be reordered both in preview and final downloads.`,
      points: ["View a Sample Product Datasheet PDF"],
      image: features7,
      reverse: false,
    },
    {
      number: "08",
      title: "B2C-like Ordering Experience for B2B Customers",
      description:
        "Selzor brings a modern, intuitive ordering interface for wholesale customers. Browse products via list or thumbnail views. Use personalized badges for featured products like 'Hot Items' or 'On Clearance'. Speed up ordering with our real-time search function.",
      points: ["Placing and Managing Orders"],
      image: features8,
      reverse: true,
    },
    {
      number: "09",
      title: " Instant Order Alerts & Easy Downloads",
      description:
        "Receive instant notifications and emails when a new order is placed. The email contains a direct link to preview the order in your browser — no login required. You can also download the order as PDF or XLS (with working formulas for line totals).",
      points: ["View Order in PDF Format", "Download Order in Excel Format"],
      image: features9,
      reverse: false,
    },
    {
      number: "10",
      title: " Itemised Quantity Summary",
      description:
        "Need to quickly calculate how much stock is needed across all pending orders? Selzor's Itemised Quantity Report gives you a consolidated product-size breakdown with just one click.",
      points: ["Download Itemised Quantity PDF Report"],
      image: features10,
      reverse: true,
    },
    {
      number: "11",
      title: "Real-Time Projection Report",
      description:
        "Many wholesale buyers fill their order carts over days or weeks before placing final orders. Selzor’s Projection Report compiles these saved carts to help you forecast demand accurately.",
      points: [
        "General Projection Report (PDF)",
        "Buyer-wise Projection Report (PDF)",
      ],
      image: features11,
      reverse: false,
    },
    {
      number: "12",
      title: " Buyer-Specific Product Views & Pricing",
      description:
        "With Selzor, you have the power to tailor the catalogue experience for each buyer. Set up to 25 pricing tiers per product and assign them to specific customers. Define minimum order values, link buyers to regional sales teams, and control which products and prices they see.",
      points: ["Adding & Inviting Buyers", "Configuring Buyer Preferences"],
      image: features12,
      reverse: true,
    },
    {
      number: "13",
      title: "Branded Invitations to Onboard Buyers",
      description:
        "Once your account is ready, Selzor provides you with a personalized invitation banner to invite your wholesale buyers. It features your company branding and your Selzor App Code. Distributors also get custom invitations with their own Distributor Codes.",
      paragraph:
        "These banners can be shared via WhatsApp, iMessage, email, or social media — with just a single tap from the Selzor mobile app.",
      points: ["Invitation Templates & Share Tools"],
      image: features13,
      reverse: false,
    },
    {
      number: "14",
      title: "Private Distributor Network Management",
      description:
        "Distributors using Selzor enjoy full platform access while keeping their dealer networks private from their suppliers (you). They get a unique Distributor Code, can receive orders directly from their dealers, and generate their own projection reports.",
      paragraph:
        "If preferred, they may choose to share their dealer network with you. Distributors can place orders to you using the same catalogue you manage — maintaining full sync.",
      points: ["Setting Up & Managing Distributors"],
      image: features14,
      reverse: true,
    },
  ];

  return (
    <div>
      <Header />
      <section className="mx-auto max-w-7xl px-6 sm:px-5 md:px-0 lg:px-0 pb-5 pt-10">
        <div className="flex flex-col gap-6 sm:gap-8">
          <div className="flex flex-col items-center text-center gap-2 sm:gap-3">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-10">
              50+ Features to Streamline Your Ordering Workflow
            </h2>
            <h6 className="text-gray-600 text-base sm:text-lg">
              Fine-tune configurations to achieve peak performance while
              minimizing costs.
            </h6>
          </div>

          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex flex-col ${
                step.reverse ? "sm:flex-row-reverse" : "sm:flex-row"
              } items-stretch gap-3 sm:gap-4 md:gap-6`}
            >
              <div className="basis-full sm:basis-2/4 flex items-center justify-center">
                <div className="rounded-3xl  overflow-hidden w-full max-w-full h-[350px] flex items-center justify-center relative">
                  <div className="absolute inset-0 z-10 bg-[radial-gradient(102.5%_102.5%_at_51.72%_41.83%,_transparent_0%,_var(--[#dbf4f1])_100%)]"></div>
                  <div
                    className={`w-full h-full bg-no-repeat bg-contain bg-center relative z-20 ${
                      step.reverse
                        ? "scale-[1.1] sm:scale-100 bg-bottom lg:bg-[center_20px]"
                        : "scale-[1.0] sm:scale-[1.0] md:scale-[1] bg-[73%_center] lg:bg-[60%_center]"
                    }`}
                    style={{ backgroundImage: `url(${step.image})` }}
                  ></div>
                </div>
              </div>

              <div className="basis-full sm:basis-2/4 flex items-center">
                <div className="flex flex-col gap-4 sm:pb-3">
                  <div className="w-[60px] h-[60px] bg-[#dbf4f1] rounded-2xl flex items-center justify-center shrink-0">
                    <span className="text-2xl leading-none text-[#1a9588]">
                      {step.number}
                    </span>
                  </div>
                  <h4 className="text-2xl text-start">{step.title}</h4>
                  <p className="text-start text-gray-600">{step.description}</p>
                  <p
                    className="text-start text-gray-600"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {step.paragraph}
                  </p>
                  <div className="text-start text-sm text-gray-600 font-semibold">
                    <h3>Learn More:</h3>
                  </div>
                  <div className="grid grid-cols-12">
                    {step.points.map((point, i) => (
                      <div key={i} className="col-span-12 lg:col-span-6">
                        <div className="flex flex-row gap-1 py-0.5 lg:py-1.5">
                          <TbRosetteDiscountCheck className="text-2xl text-gray-500" />
                          <p className="text-start text-sm text-gray-500">
                            {point}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-7xl py-20 px-6 sm:px-5 md:px-0 lg:px-0 pb-5 pt-20">
          <div className="flex flex-col sm:flex-row gap-3 items-stretch">
            <div className="basis-full sm:basis-1/2">
              <div className="animate-y delay-reset rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden flex flex-col h-full">
                <div className="p-6 sm:p-8 md:p-8 flex flex-col items-start gap-8 sm:gap-10 h-full justify-between">
                  <div className="relative flex items-center justify-center">
                    <TbCloudUp className="text-[26px] sm:text-4xl text-[#2e847a] leading-none absolute z-10" />
                    <svg
                      className="w-[60px] h-[60px] sm:w-[70px] sm:h-[70px] lg:w-[80px] lg:h-[80px] stroke-[2.90909]"
                      viewBox="0 0 84 84"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M47.552 4.67508L45.6912 3.14787C43.5455 1.38675 40.4545 1.38675 38.3088 3.14787L36.448 4.67509C35.6785 5.30667 34.6395 5.50091 33.6937 5.18995L31.407 4.43804C28.7699 3.57097 25.8877 4.68757 24.523 7.10489L23.3396 9.20116C22.8502 10.0681 21.9515 10.6245 20.9573 10.6762L18.5533 10.8012C15.7812 10.9452 13.4969 13.0276 13.0976 15.7747L12.7514 18.1569C12.6082 19.1421 11.9712 19.9856 11.0628 20.3929L8.86631 21.3779C6.33339 22.5136 4.95561 25.2806 5.57567 27.9864L6.11338 30.3328C6.33575 31.3031 6.04647 32.3198 5.34657 33.0278L3.65418 34.7397C1.70259 36.7138 1.41739 39.7916 2.97302 42.0907L4.32203 44.0844C4.87993 44.9089 4.97746 45.9614 4.58057 46.8744L3.62087 49.0821C2.51418 51.6278 3.36008 54.6008 5.64117 56.1827L7.61931 57.5545C8.43737 58.1218 8.90854 59.068 8.86826 60.0627L8.77086 62.468C8.65855 65.2416 10.5213 67.7083 13.2198 68.3593L15.5599 68.9239C16.5276 69.1573 17.3088 69.8695 17.6306 70.8115L18.4086 73.0896C19.3059 75.7165 21.9339 77.3437 24.6853 76.9759L27.0713 76.657C28.0581 76.5251 29.0438 76.907 29.6841 77.6692L31.2326 79.5123C33.0181 81.6377 36.0565 82.2057 38.4893 80.8689L40.599 79.7096C41.4715 79.2301 42.5285 79.2301 43.401 79.7096L45.5107 80.8689C47.9435 82.2057 50.9818 81.6377 52.7674 79.5123L54.3159 77.6692C54.9562 76.907 55.9419 76.5251 56.9286 76.657L59.3147 76.9759C62.0661 77.3437 64.6941 75.7165 65.5914 73.0896L66.3694 70.8115C66.6912 69.8695 67.4724 69.1573 68.4401 68.9239L70.7802 68.3593C73.4787 67.7083 75.3414 65.2416 75.2291 62.468L75.1317 60.0627C75.0915 59.068 75.5626 58.1218 76.3807 57.5545L78.3588 56.1827C80.6399 54.6008 81.4858 51.6278 80.3791 49.0821L79.4194 46.8744C79.0225 45.9614 79.1201 44.9089 79.678 44.0844L81.027 42.0907C82.5826 39.7916 82.2974 36.7138 80.3458 34.7397L78.6534 33.0278C77.9535 32.3198 77.6642 31.3031 77.8866 30.3328L78.4243 27.9864C79.0444 25.2806 77.6666 22.5136 75.1337 21.3779L72.9372 20.3929C72.0288 19.9856 71.3918 19.1421 71.2486 18.1569L70.9024 15.7747C70.5031 13.0276 68.2188 10.9452 65.4467 10.8012L63.0427 10.6762C62.0485 10.6245 61.1498 10.0681 60.6604 9.20115L59.477 7.10489C58.1123 4.68757 55.2301 3.57097 52.593 4.43804L50.3062 5.18995C49.3605 5.50091 48.3215 5.30667 47.552 4.67508Z"
                        fill="url(#paint0_linear)"
                        stroke="url(#paint1_linear)"
                        strokeWidth="2.90909"
                      ></path>

                      <defs>
                        <linearGradient
                          id="paint0_linear"
                          x1="82"
                          y1="42"
                          x2="2"
                          y2="42"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#D4E6E2"></stop>
                          <stop offset="1" stopColor="#dbf4f1"></stop>
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear"
                          x1="84.8571"
                          y1="42.7143"
                          x2="-3"
                          y2="42.7143"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#dbf4f1"></stop>
                          <stop offset="1" stopColor="#D4E6E2"></stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="flex flex-col gap-2 sm:gap-3">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 text-start sm:mb-3">
                      One App for All Your B2B Order Needs
                    </h2>
                    <h6 className="text-gray-600 text-base sm:text-xl text-start">
                      Selzor allows brands, distributors, wholesalers, and
                      retailers to manage orders in both Buyer & Seller modes
                      with a single login.
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="basis-full sm:basis-1/2">
              <div className="animate-y p-4 lg:p-10 rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden flex flex-col h-full">
                <div className="flex flex-col">
                  {[
                    {
                      label: "Multiple Buyer & Seller Modes",
                      value: 100,
                      unit: "%",
                      width: "100%",
                    },
                    {
                      label: "Instant Order Switch",
                      value: 1,
                      unit: "Click",
                      width: "90%",
                    },
                    {
                      label: "Unified Order Management",
                      value: 99,
                      unit: "%",
                      width: "99%",
                    },
                    {
                      label: "Real-Time Notifications",
                      value: 100,
                      unit: "%",
                      width: "100%",
                    },
                  ].map((kpi, i) => (
                    <div
                      key={i}
                      className="flex flex-row items-center py-3 sm:py-5 gap-2 lg:gap-3"
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <h4 className="text-xl sm:text-xl lg:text-2xl text-gray-800 mb-2 sm:mb-3 text-start">
                          {kpi.label}
                        </h4>
                        <div className="w-full bg-[#DDE4E1] rounded-lg h-[6px]">
                          <div
                            className="bg-[#2e847a] h-full rounded-lg"
                            style={{ width: kpi.width }}
                          ></div>
                        </div>
                      </div>
                      <div className="flex flex-row items-end">
                        <div className="text-2xl font-semibold">
                          {kpi.value}
                        </div>
                        <div className="text-2xl font-semibold mb-0.5 md:mb-1">
                          {kpi.unit}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FloatingButton />
      <Footer />
    </div>
  );
};

export default Features;
